export interface ICounts {
    accepted: number,
    preferred: number,
    nonPreferred: number,
    bioMatches: number,
    zeroPmp: number,
    aboIncompatible: number,
    avoidConflict: number,
    all: number
}